import { CurrencyField } from '@/components/form/fields/text/CurrencyInput';
import { Dinero } from '@/components/form/fields/text/helpers/currency';
import MarginField from '@/components/margin/MarginField';
import { FC } from 'react';
import { z } from 'zod';

export const PriceAndMarginFormFields = z.object({
  price: Dinero,
  modifier: z.string().min(1),
  effectiveDate: z.date().optional()
});

export type PriceAndMarginFormFields = z.infer<typeof PriceAndMarginFormFields>;

interface Props {
  regionCode?: string;
}

export const PriceAndMarginForm: FC<Props> = ({ regionCode }) => {
  return (
    <>
      <CurrencyField regionCode={regionCode} className="col-span-2" id="price" label="Price" placeholder="1,000.00" />
      <MarginField id="modifier" className="col-span-2" />
    </>
  );
};
